import { useMemo } from 'react'
import useValidation from 'tennders-common/hooks/useValidation'

const useTruckSubmitRules = () => {
  const { requiredFieldAny, requiredFieldBoolean } = useValidation()

  const truckSubmitRules = useMemo(() => ({
    company: requiredFieldAny(),
    cmrType: requiredFieldAny(),
    dimension: requiredFieldAny(),
    height: requiredFieldAny(),
    paymentTerm: requiredFieldAny(),
    paymentTermDays: requiredFieldAny(),
    price: requiredFieldAny(),
    truckType: requiredFieldBoolean(),
    volume: requiredFieldAny(),
    volumeType: requiredFieldAny(),
    weight: requiredFieldAny()
  }), [])

  const pickupRouteRules = useMemo(() => ({
    location: requiredFieldAny(),
    date: requiredFieldAny()
  }), [])

  return {
    truckSubmitRules,
    pickupRouteRules
  }
}

export default useTruckSubmitRules
